// components
import { LAYOUT_DEFAULT } from "../components/layouts";

export default function PAGE_NOT_FOUND () {
    return (
        <LAYOUT_DEFAULT pageName={ "404" }>
            <section>Page not found</section>
        </LAYOUT_DEFAULT>
    )
}